type HeroBanner = {
  init: () => void;
};

const HeroBanner: HeroBanner = {
  init() {
    const heroBanner = document.querySelector('[data-hook=heroBanner]') as HTMLElement;
    if (!heroBanner) return;

    const videoButton = heroBanner.querySelector(
      '[data-hook=heroBanner__videoButton]',
    ) as HTMLButtonElement;
    if (!videoButton) return;

    const options = heroBanner.dataset.options ? JSON.parse(heroBanner.dataset.options) : '';
    const videoButtonTextWrapper = videoButton.querySelector('span');

    videoButton.addEventListener('click', () => {
      const relatedVideo = videoButton.nextElementSibling as HTMLVideoElement;
      if (!(relatedVideo instanceof HTMLVideoElement)) return;

      if (relatedVideo.paused) {
        relatedVideo.play();
        videoButton.classList.remove('is-paused');
        if (options.videoButtonText.play && videoButtonTextWrapper) {
          videoButtonTextWrapper.innerText = options.videoButtonText.pause;
        }
      } else {
        relatedVideo.pause();
        videoButton.classList.add('is-paused');
        if (options.videoButtonText.pause && videoButtonTextWrapper) {
          videoButtonTextWrapper.innerText = options.videoButtonText.play;
        }
      }
    });
  },
};

export default HeroBanner;
